exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading[data-v-1b07aa32]{width:100%;height:100%;background-repeat:no-repeat;background-size:contain;background-position:50%;position:fixed;top:0;left:0;background-color:#403f3f;z-index:9999;opacity:.8}.loading img[data-v-1b07aa32]{position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;width:40px}@media screen and (max-width:575px){.loading img[data-v-1b07aa32]{width:20vw}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b07aa32","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/LoadingView.vue
// module id = 6Ndy
// module chunks = 1